import React from "react";
import { ImageUrlPrefix } from "../../../../../labels";

import moment from "moment";
import { useParams } from "react-router-dom";
import DatePickerSample from "../../../DatePicker";

function MockInterviewDetail(props) {
  const isDisabled = props.record.status == 2;
  return (
    <div className="row box ">
      <div className="col-md-12">
        <p className="StepTitle">
          {" "}
          Interview {props.record.exam_count > 0 ? "" : ""}{" "}
          {props.record.exam_count > 0 ? props.record.exam_count : ""} Details
        </p>
        <div className="row mb-4" style={{
          paddingRight: "20px",
          opacity: isDisabled ? 0.7 : 1,
          pointerEvents: isDisabled ? "none" : "auto",
        }}>
          {/* title */}
          <div className="col-md-6">
            <div className="forms ">
              <label for="title">{" Interview Title"}</label>
              <input
                ref={props.txtBatchMockETitle}
                type="text"
                class="Inputs"
                id="title"
                name="title"
                disabled={isDisabled}
                placeholder="Interview Title"
                value={props.record.title}
                onChange={(e) => props.examdetailschange(e, props.record.id)}
              />
              {props.record.error_1 && (
                <small className="error">{props.record.error_1}</small>
              )}
            </div>
          </div>
          {/* upload syllabus */}
          <div className="col-md-6">
            <div className="forms ">
              <label for="syllabus">
                Upload Syllabus (in pdf/Image format):
                {props.record &&
                  props.record.syllabus !== undefined &&
                  props.record.syllabus !== null &&
                  props.record.syllabus !== "" && (
                    <a
                      href={`${ImageUrlPrefix}/${props.record.syllabus}`}
                      target="_blank"
                      download
                    >
                      <span className="material-icons align-middle download_icon">
                        file_download
                      </span>
                    </a>
                  )}
              </label>
              <div className="row">
                <div
                  className={
                    props.record.syllabus !== "" &&
                      props.record.syllabus !== null
                      ? "col-md-3 "
                      : "col-md-12"
                  }
                >
                  <input
                    ref={props.txtBatchMockEsyllabus}
                    type="file"
                    className={
                      props.record.syllabus !== "" &&
                        props.record.syllabus !== null
                        ? "InputsFilessss nn_upload_width"
                        : "InputsFilessss  vv_upload_width"
                    }
                    id="syllabus"
                    name="syllabus"
                    disabled={isDisabled}
                    onChange={(e) =>
                      props.examdetailschange(e, props.record.id)
                    }
                  />
                </div>
                {props.record.syllabus !== "" &&
                  props.record.syllabus !== null && (
                    <div className={"col-md-9 d-flex align-content-center p-0"}>
                      <span className="nn_upload_file">
                        {props.record.syllabus !== "" &&
                          props.record.syllabus !== null
                          ? props.record.original_syllabus_url
                          : ""}
                      </span>
                      {props.record &&
                        props.record.syllabus !== undefined &&
                        props.record.syllabus !== null &&
                        props.record.syllabus !== "" && (
                          <span className="material-icons align-middle text-danger verified_upload">
                            verified
                          </span>
                        )}

                    </div>
                  )}
              </div>

              {props.record.error_6 && (
                <small className="error">{props.record.error_6}</small>
              )}
            </div>
          </div>
          {props.interview_type == "0" && (
            <div className="col-md-6">
              <div className="forms ">
                <label for="LastDateApply">Last Date To Apply:</label>

                <DatePickerSample
                  minDate={moment().toDate()}
                  txtAdMDob={props.txtBatchMockDapply}
                  name={"LastDateApply"}
                  handleIdChange={(date) =>
                    props.examdetailschange_date(
                      date,
                      props.record.id,
                      "LastDateApply"
                    )
                  }
                  fieldsId={props.record.id}
                  disabledProperty={isDisabled}
                  fieldInput={
                    props.record.LastDateApply
                      ? moment(props.record.LastDateApply).format("DD/MM/YYYY")
                      : props.record.LastDateApply
                  }
                />
                {props.record.error_8 && (
                  <small className="error">{props.record.error_8}</small>
                )}
              </div>
            </div>
          )}

          {/* date */}
          <div className="col-md-6">
            <div className="forms ">
              <label for="date">Interview Date</label>
              <DatePickerSample
                minDate={props.minExamDate}
                txtAdMDob={props.txtBatchEdate}
                name={"date"}
                handleIdChange={(date) =>
                  props.examdetailschange_date(date, props.record.id, "date")
                }
                fieldsId={props.record.id}
                disabledProperty={isDisabled}
                fieldInput={
                  props.record.date
                    ? moment(props.record.date).format("DD/MM/YYYY")
                    : props.record.date
                }
              />
              <small
                className="pt-1 "
                style={{
                  display: props.record.LastDateApply ? "none" : "inline-block",
                  color: "grey",
                  textAlign: "center",
                }}
              ></small>
              {props.record.error_2 && (
                <small className="error">{props.record.error_2}</small>
              )}
            </div>
          </div>

          {props.id && (
            <div className="col-lg-4 col-md-6">
              <div className="forms ">
                <label
                  htmlFor="inputName"
                  className="form-label text-muted mt-3 "
                >
                  Hall Ticket Status
                </label>
                <span className="ReviewLabel">
                  {props.record.status == 2 ? "Generated" : "Not Yet Generated" || "_"}
                </span>
              </div>
            </div>
          )}
          {/* last date apply */}
        </div>
      </div>
    </div>
  );
}
export default MockInterviewDetail;
